import { StateChange } from '~/components/txn-display/state-change/types'
import { BackendTransaction, BasicTransactionType } from '~/types'
import { Address } from '~/utils/address'

export const useBridgePendingStateChanges = (
  transaction: BackendTransaction,
): StateChange[] | undefined => {
  if (!transaction.transactionRecipients?.length) return undefined

  if (
    !transaction.isMerkleTransaction &&
    transaction.types?.includes(BasicTransactionType.Bridge)
  ) {
    return transaction.transactionRecipients.map((recipient) => {
      return {
        address: Address.format(recipient.recipientAddress),
        token: Address.format(recipient.endTokenAddress),
        chainId: recipient.endChainId,
        amount: BigInt(recipient.expectedAmount),
      }
    })
  }

  return undefined
}
